import { SSO_GROUPS_KEY_ID } from '@lucidlink/dto/validation';
import { arrayToBase64, cryptoKeyToArray, cryptoKeyToBase64, encryptCryptoKeyWithPublicKey, encryptSignRsaBlockCipher, generateAesGcmKey, generateEncryptPair, signRsa, } from '@lucidlink/ts-crypto/crypto';
import { signWorkspaceCryptoTuple } from './crypto/crypto-utils';
export const prepareWorkspaceCrypto = async (params) => {
    const [workspaceSecretKey, ssoGroupsKeys, everyoneKeys, adminKeys] = await Promise.all([
        generateAesGcmKey(),
        generateEncryptPair(),
        params.adminCrypto.verifyAndGetEveryoneKeys(),
        params.adminCrypto.verifyAndGetAdminKeys(),
    ]);
    const workspaceKeyArray = await cryptoKeyToArray(workspaceSecretKey);
    const [seWorkspaceSecretKeyByAdminKey, sWorkspaceSecretKeyByAdminKey, ssoGroupsPublicKey, eSsoGroupsPrivateKeyByAdminKey, eSsoGroupsPrivateKeyByEveryoneKey, sSsoGroupsPublicKeyByAdminKey,] = await Promise.all([
        encryptSignRsaBlockCipher(workspaceKeyArray, adminKeys),
        signRsa(workspaceKeyArray, adminKeys.signPair.privateKey).then(arrayToBase64),
        cryptoKeyToBase64(ssoGroupsKeys.publicKey),
        encryptCryptoKeyWithPublicKey(ssoGroupsKeys.privateKey, adminKeys.encryptPair.publicKey),
        encryptCryptoKeyWithPublicKey(ssoGroupsKeys.privateKey, everyoneKeys.publicKey),
        signWorkspaceCryptoTuple({
            id: SSO_GROUPS_KEY_ID,
            workspaceId: params.workspaceId,
            publicKey: ssoGroupsKeys.publicKey,
        }, adminKeys.signPair.privateKey),
    ]);
    const workspaceSecretKeyBase64 = params.includeWorkspaceKeyInDto
        ? arrayToBase64(workspaceKeyArray)
        : undefined;
    return {
        workspaceCryptoDto: {
            workspaceSecretKey: workspaceSecretKeyBase64,
            seWorkspaceSecretKeyByAdminKey,
            sWorkspaceSecretKeyByAdminKey,
            ssoGroupsPublicKey,
            sSsoGroupsPublicKeyByAdminKey,
            eSsoGroupsPrivateKeyByAdminKey,
            eSsoGroupsPrivateKeyByEveryoneKey,
        },
        keys: { workspaceSecretKey },
    };
};
